export { default } from './DocumentMalwareTag';
